import { useEffect, useState } from 'react';
import { WbText } from '@workbench/react';
import { useTranslation } from 'react-i18next';

import VimdtButton from '../Common/VimdtButton';
import VimdtAccordion from '../Common/VimdtAccordion';
import CollapseAllToggle from '../Common/CollapseAllToggle';
import ImageRenderList from './ImageRenderList';
import Image360View from './Image360View';
import ImageCompose from './ImageCompose';
import { exampleVin } from './exampleImages';
import './ExampleImageList.scss';

function ExampleImageList({ imageList, rowCount = 6 }) {
	const { t } = useTranslation();
	const [panels, setPanels] = useState([]);
	const [availablePanels, setAvailablePanels] = useState([]);

	useEffect(() => {
		setAvailablePanels([exampleVin]);
	}, [imageList]);

	const count = imageList[exampleVin]?.length ?? 0;

	const panelHandler = (mode) => setPanels(mode === 0 ? availablePanels : []);

	const saveButton = (
		<VimdtButton label={t('vimdt.loadSaveButtons.saveImages')} filledIn={false} disabled />
	);

	return (
		<div className="vimdt-example-list">
			<div className="vimdt-example-list__header">
				<WbText strong>{`${count} ${t('vimdt.infoTexts.imagesFound')}`}</WbText>
				{saveButton}
			</div>

			<CollapseAllToggle
				panelHandler={panelHandler}
				panels={panels}
				availablePanels={availablePanels}
			/>

			<Image360View images={imageList} />
			<ImageCompose images={imageList} sample />

			<VimdtAccordion
				activeKeys={panels}
				onChange={setPanels}
				items={[
					{
						key: exampleVin,
						header: exampleVin,
						content: (
							<ImageRenderList
								vin={exampleVin}
								imageList={imageList[exampleVin]}
								rowCount={rowCount}
								innerPanels
							/>
						),
					},
				]}
			/>

			<div className="vimdt-example-list__footer">{saveButton}</div>
		</div>
	);
}

export default ExampleImageList;
